import Swiper, {Autoplay} from 'swiper';

Swiper.use([Autoplay]);

const swiper = new Swiper('.title__swiper', {
      slidesPerView: 'auto',
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 1500,
      },
});
